import { render, staticRenderFns } from "./RRadio.vue?vue&type=template&id=04052a64&scoped=true"
import script from "./RRadio.vue?vue&type=script&lang=js"
export * from "./RRadio.vue?vue&type=script&lang=js"
import style0 from "./RRadio.vue?vue&type=style&index=0&id=04052a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04052a64",
  null
  
)

export default component.exports